import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface SendHL7Recipient {
  id: string;
  firstName?: string;
  lastName?: string;
  prefix?: string;
  idType?: string;
}

export interface SendHL7SendingProvider {
  id: string;
  firstName?: string;
  lastName?: string;
  prefix?: string;
  idType?: string;
}

export interface SendHL7Payload {
  reportId: string;
  recipient: SendHL7Recipient;
  sendingProvider?: SendHL7SendingProvider;
  siteId?: number;
  skipAvailabilityCheck?: boolean;
  /** Display segment format sent in the HL7 OBX: 'pdf' (default), 'txt', or 'rtf' */
  format?: 'pdf' | 'txt' | 'rtf';
}

export const sendHL7Api = createAsyncThunk(
  'hl7/sendHL7',
  async (payload: SendHL7Payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const response = await fetch(HL7.SEND, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Send failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
